module.exports = __webpack_public_path__ + "img/AR-Openpay-GO-UX-V02.401cdce0.svg";